import React from "react";

import { ALink } from "../../../../components/Atoms";

import {
  Wrapper,
  FooterPlayIcon,
  IconBox,
  DownloadCta,
  DownloadText,
} from "./styles";

function RHSSection({ appLinks = [], width, mobileLink }) {
  return (
    <Wrapper>
      {width > 768 ? (
        appLinks?.map((link) => (
          <IconBox key={link.text}>
            <ALink href={link.link} target="_blank">
              <FooterPlayIcon
                className="img-fluid lazyload loaded"
                src={link.iconDark}
              />
            </ALink>
          </IconBox>
        ))
      ) : (
        <DownloadCta target="_blank" variant="link1" href={mobileLink}>
          <DownloadText variant="label2">DOWNLOAD</DownloadText>
        </DownloadCta>
      )}
    </Wrapper>
  );
}

export default RHSSection;
